import React, { useEffect, useState } from 'react';
import { apiRequest } from "../services/api";
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

const Cruise = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [datas, setDatas] = useState([]);

    useEffect(() => {
        apiRequest({ url: "/cruise-lines?category=Popular" })
            .then((res) => {
                if (res.success) {
                    const shuffled = res.data.sort(() => 0.5 - Math.random()); // Randomize array
                    const selected = shuffled.slice(0, 3); // Pick first 3
                    setData(selected);
                } else {
                    console.warn("Unexpected response format:", res);
                }
            })
            .catch((err) => {
                console.error("Error loading hero slides:", err.message);
            });
        apiRequest({ url: "/cruise-lines?category=Luxury" })
            .then((res) => {
                if (res.success) {
                    const shuffled = res.data.sort(() => 0.5 - Math.random()); // Randomize array
                    const selected = shuffled.slice(0, 3); // Pick first 3
                    setDatas(selected);
                    // setDatas(res.data);
                } else {
                    console.warn("Unexpected response format:", res);
                }
            })
            .catch((err) => {
                console.error("Error loading hero slides:", err.message);
            })
    }, []);
    return (
        <section className="d-flex flex-column flex-md-row w-100">
            {/* Left Half: Full Height Image */}
            <div className="col-md-6 p-0">
                <img
                    src="/img/home-cruise.jpg" // replace with your image path
                    alt="Cruise"
                    className="w-100 h-100 object-fit-cover"
                    style={{
                        objectFit: "cover",
                        height: "100vh",
                        width: "100%",
                    }}
                />
            </div>

            {/* Right Half: Content */}
            <div className="col-md-6 bg-light p-5 px-4">
                <div >
                    <div className="mx-auto text-center mb-5" >
                        <h5 className="section-title px-3">Cruise</h5>
                        <h2 className="mb-0">Popular Cruise Lines</h2>
                    </div>
                    <div className="d-flex flex-wrap justify-content-center gap-4">
                        {data.map((line) => (
                            <div key={line.id} className="cruise-card"
                                onClick={() => navigate(`/cruise/${line.slug}`, { state: line.id })}
                            >
                                <div className="card d-flex align-items-center justify-content-center p-3 rounded shadow">
                                    <img
                                        src={line.logo}
                                        alt={line.name}
                                        className="cruise-logo"
                                    />
                                    {/* <h6 className="mt-2 mb-0">{line.name}</h6> */}
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="mx-auto text-center mb-5 mt-5" >
                        <h2 className="mb-0">Luxury Cruise Lines</h2>
                    </div>
                    <div className="d-flex flex-wrap justify-content-center gap-4">
                        {datas.map((line) => (
                            <div key={line.id} className="cruise-card"
                                onClick={() => navigate(`/cruise/${line.slug}`, { state: line.id })}
                            >
                                <div className="card d-flex align-items-center justify-content-center p-3 rounded shadow">
                                    <img
                                        src={line.logo}
                                        alt={line.name}
                                        className="cruise-logo"
                                    />
                                    {/* <h6 className="mt-2 mb-0">{line.name}</h6> */}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className='text-center mt-5'>
                        <Link
                            to="/our-partner-cruise-lines"
                            className="btn-hover-bg btn btn-primary rounded-pill text-white py-3 px-5"
                        >
                            Explore More
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Cruise